import {LivePenaltiesModuleConfig} from "./live-penalties-module.config";
import {LivePenaltiesModuleStore} from "./live-penalties-module.store";
import {LivePenaltiesModuleHandlers} from "./handlers/live-penalties-module.handlers";
import {ModuleController} from "../../infrastructure/controllers/module-controller";
import {BaseManagedService} from "../../infrastructure/domain-services/base-managed-service";

export class LivePenaltiesModuleController extends ModuleController {
  static injectables = [...BaseManagedService.injectables, LivePenaltiesModuleConfig, LivePenaltiesModuleStore, LivePenaltiesModuleHandlers];

}
